import { Switch } from 'antd';
import FormField from 'components/FormField';
import { useTranslate } from '@tolgee/react';
import { FV } from './share';

function EnableField({ disabled = false }: { disabled?: boolean }) {
  const { t } = useTranslate();

  return (
    <FormField<FV['enable']> required name="enable" label={t('aide.任务开关')}>
      {({ field: { value, onChange } }) => {
        return (
          <Switch
            disabled={disabled}
            checked={value}
            onChange={onChange}
            checkedChildren={t('aide.开')}
            unCheckedChildren={t('aide.关aide.开')}
          />
        );
      }}
    </FormField>
  );
}

export default EnableField;
